module.exports = __webpack_public_path__ + "img/800_5a281d5cab608.e983fb8b.jpg";